import { ContentItem } from '@kentico/kontent-delivery';
import { ISocialMediaPanelProps } from '../components/social-media-panel/social-media-panel';
import get from 'lodash/get';

export class SocialMediaPanelModel extends ContentItem {
  get linkedinUrl(): string {
    return get(this._config, 'elements.linkedin_url.value', {});
  }

  get githubUrl(): string {
    return get(this._config, 'elements.github_url.value', {});
  }

  get facebookUrl(): string {
    return get(this._config, 'elements.facebook_url.value', {});
  }

  public static create(data: ISocialMediaPanel): ISocialMediaPanelProps {
    const { linkedinUrl, githubUrl, facebookUrl } = new SocialMediaPanelModel(
      data
    );
    return {
      linkedinUrl,
      githubUrl,
      facebookUrl
    };
  }
}
